import { Component, OnInit, OnDestroy } from '@angular/core';
import { Platform, ModalController, LoadingController } from '@ionic/angular';
import { Proforma, ProformasFilter, ProformasOrder, ProformasOrderType, CsiteSupplier, DocumentProformaReport } from '@arpada/arp-lib-common-qupro';
import { Subscription } from 'rxjs';

import { PortalProveedorService, ProformaPopulateService, MessagesService, FileDownloadService, GeneralPopulateService } from '../../services/api.services';
import { Constants, DatatableMessage, Page, ProformaFront } from '../../models/api.models';

import { SelectorCsiteComponent } from '../csites/selector-csite/selector-csite.component';
import { ProformaData } from './proforma.data';
import { ActionsSharedData } from '../shared/actions-header/actions.shared.data';

@Component({
  selector: 'app-proformas',
  templateUrl: './proformas.component.html',
  styleUrls: ['./proformas.component.scss'],
})
export class ProformasComponent implements OnInit, OnDestroy {

  proformas: Proforma[];
  proformasFront: ProformaFront[] = [];
  csites: CsiteSupplier[] = [];

  showListButton =  false;
  showCardListButton = true;
  showList = true;
  showCardList = false;

  proformasFilter: ProformasFilter = new ProformasFilter();
  proformasOrder: ProformasOrder = new ProformasOrder(ProformasOrderType.DEFAULT_ORDER);
  sharedData: ActionsSharedData = new ActionsSharedData();
  filtroProforma = true;

  totalCount = '-';
  totalCountNumber = -1;
  private lastTimestampLoadIssues: number = null;

  proformaData: ProformaData = new ProformaData();

  private lineaProformaUpdatedSubscription: Subscription;
  private proformaCreatedSubscription: Subscription;
  private selectOperatorSubscription: Subscription;
  private resolveDocumentDownload: (toResolve: boolean) => void;
  proformasToExport: Proforma[] = [];

  private loadingWidget: HTMLIonLoadingElement = null;
  private resolveActionSheetActionSelected: (toResolve: boolean) => void;
  private rejectActionSheetActionSelected: (toReject: boolean) => void;
  private readonly actionSheetPromiseExecutor =
      (resolveFun: (toResolve: boolean) => void, rejectFun: (toReject: boolean) => void) => {
          this.resolveActionSheetActionSelected = resolveFun;
          this.rejectActionSheetActionSelected = rejectFun;
      }


  constructor(private portalProveedorService: PortalProveedorService,
              private proformaPopulateService: ProformaPopulateService,
              private messages: MessagesService,
              private generalPopulateService: GeneralPopulateService,
              private fileDownloadService: FileDownloadService,
              private modalCtrl: ModalController,
              private loadingController: LoadingController,
              private platform: Platform) {
    this.initFilter();
    this.initProformaData();
    this.initPage();
    this.setHeight(this.platform.height());
  }

  ngOnDestroy(): void {
    if (this.lineaProformaUpdatedSubscription) {
      this.lineaProformaUpdatedSubscription.unsubscribe();
    }
    if (this.proformaCreatedSubscription) {
      this.proformaCreatedSubscription.unsubscribe();
    }
    if (this.selectOperatorSubscription) {
      this.selectOperatorSubscription.unsubscribe();
    }
  }

  initProformaData() {
    this.proformaData.proformasFront = [];
    this.proformaData.msg = new DatatableMessage();
    this.proformaData.msg.emptyMessage = '';
    this.proformaData.msg.totalMessage = 'total';
    this.proformaData.page = new Page();
  }

  async ngOnInit() {
    this.setTotalCount(-1);
    this.messages.onInitTranslateService().subscribe( () => {
      const globalOperatorSelected = this.portalProveedorService.getOperatorSel();
      this.portalProveedorService.getSupplierCsitesCached(globalOperatorSelected, 'combo-proformable-proveedor').subscribe(resp => {
        this.csites = resp.elements;
      });
      this.getProformas(this.proformaData.page);

      this.lineaProformaUpdatedSubscription = this.portalProveedorService.updateLineaProformaEvent
        .subscribe((proformaUpdateFront: ProformaFront) => {
          this.onUpdateProformaEvent(proformaUpdateFront);
        });

      this.proformaCreatedSubscription = this.portalProveedorService.createProformaEvent
        .subscribe(resp => {
          this.getProformas(this.proformaData.page);
        });

      this.selectOperatorSubscription = this.portalProveedorService.selectOperatorEvent.subscribe(operatorId => {
        this.proformasFilter.operator_num = operatorId;
        this.getProformas(this.proformaData.page);
      });
    });
    this.loadingWidget = await this.loadingController.create({
      message: this.messages.getLoadingActionMessage(),
      duration: 0,
      backdropDismiss: false,
      showBackdrop: true,
    });
    this.closeLoading();
    this.loadingWidget.present();
  }

  onCreateProformaEvent(proformaCreatedFront: ProformaFront) {
    this.proformaData.proformasFront.push(proformaCreatedFront);
  }

  onUpdateProformaEvent(proformaUpdateFront: ProformaFront) {
    this.proformaData.proformasFront.forEach(proformaFront => {
      if (proformaFront.id === proformaUpdateFront.id) {
        Object.assign(proformaFront, proformaUpdateFront);
      }
    });
  }

  onGetProformas(envio){
    this.getProformas(envio.page);
    this.setTotalCount(envio.total);
  }

  onFilterChange(filtroRecibido) {
    this.setTotalCount(-1);
    const filterTemp = new ProformasFilter();
    Object.assign(filterTemp, filtroRecibido);
    this.proformasFilter = filterTemp;
    this.initPage();
    this.getProformas(this.proformaData.page);
  }

  onListPressed(event: Event) {
    this.showListButton = false;
    this.showCardListButton = true;
    this.showList = true;
    this.showCardList = false;

  }

  onCardListPressed(event: Event) {
    this.showListButton = true;
    this.showCardListButton = false;
    this.showList = false;
    this.showCardList = true;
  }

  onRowSelected(proformasFront: ProformaFront[]) {
    this.proformasToExport = [];
    if (proformasFront.length > 0) {
      this.proformasToExport = this.proformaPopulateService.convertirProformasFrontToProformas(proformasFront);
    }
  }

  onCreateProformaPressed(event: Event) {
    this.nuevaProforma();
  }

  onExportProformasPressed(proformasToExport: Proforma[]): Promise<boolean>  {
    this.showLoading();
    if (proformasToExport) {
      if (proformasToExport.length > 0) {
        const proformasIds: number [] = [];
        proformasToExport.forEach((proforma: Proforma) => {
          proformasIds.push(proforma.id);
        });
        this.portalProveedorService.downloadProformas(proformasIds).subscribe((docProformaReport: DocumentProformaReport) => {
          const loggerName = 'documento ' + docProformaReport.filename + new Date().toString;
          this.fileDownloadService.completeDownloadAction(docProformaReport.filename,
            docProformaReport.mimetype, docProformaReport.data, loggerName)
            .then(() => {
                this.resolveDocumentDownload(true);
            }).catch(() => {
                this.resolveDocumentDownload(false);
            }).finally(() => {
                this.closeLoading();
            });
        });
      }
      return new Promise<boolean>(this.actionSheetPromiseExecutor);
    }
  }

  async nuevaProforma() {
    const modal = await this.modalCtrl.create({
      component: SelectorCsiteComponent,
      componentProps: {
        isModal: true,
        afterLogin: false,
        csites: this.csites
      }
    });
    return await modal.present();
  }

  private getProformas(page: Page) {
    const start = page.offset * page.limit;
    const limit = page.limit;
    this.proformaData.proformasFront = [];
    this.proformaData.msg.emptyMessage = this.generalPopulateService.changeMms(true);
    this.lastTimestampLoadIssues = new Date().getTime();
    const timestampToUseInTransform = this.lastTimestampLoadIssues;
    this.portalProveedorService.getProformasSupplier(this.proformasFilter, this.proformasOrder, start, limit).subscribe(resp => {
      // para evitar concurrencia
      if (timestampToUseInTransform === this.lastTimestampLoadIssues) {
        this.setTotalCount(resp.count);
        this.proformas = resp.elements;
        // console.log('proformas: ', this.proformas);
        this.proformaData.page.count = resp.count;
        this.proformasFront = this.proformaPopulateService.convertirProformasToProformasFront(this.proformas);
        this.proformaData.proformasFront = this.proformasFront;
        this.proformaData.msg.emptyMessage = this.generalPopulateService.changeMms(false);
      }
    });
  }

  private setHeight(height: number) {
    if (height <= 650) {
      this.proformaData.page.limit = 6;
    }
    if (height > 650 && height <= 736) {
      this.proformaData.page.limit = 7;
    }
    if (height > 736 &&  height <= 823) {
      this.proformaData.page.limit = 9;
    }
    if (height > 850) {
      this.proformaData.page.limit = 10;
    }
  }

  private initFilter(csiteId?: number) {
    const newFilter: ProformasFilter = new ProformasFilter();
    newFilter.setStateKeys(Constants.SUPPLIER_PROFORMAS_STATES_FILTER);
    // Assign all fields to actual filter
    Object.assign(this.proformasFilter, newFilter);
  }

  private initPage() {
    this.proformaData.page.offset = 0;
    this.proformaData.page.limit = 10;
    this.proformaData.page.count = 0;
  }

  private setTotalCount(totalCountNumber: number) {
    this.totalCountNumber = totalCountNumber;
    if (totalCountNumber >= 0) {
      this.totalCount = totalCountNumber + '';
      this.sharedData.totalCount = totalCountNumber + '';
    } else {
      this.totalCount = '-';
      this.sharedData.totalCount = '-';
    }
  }

  private showLoading() {
    this.loadingWidget.hidden = false;
  }

  private closeLoading() {
      this.loadingWidget.hidden = true;
  }
}
